import { createFileRoute } from '@tanstack/react-router';

import { Heading } from '@/common/components/heading';
import { Seo } from '@/common/components/seo';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/users/me')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: MyProfileRoute
});

function MyProfileRoute() {
  return (
    <>
      <Seo title="My Profile" />
      <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
        <Heading>My Profile</Heading>
      </div>
      <div className="mt-8">
        <p className="text-black dark:text-white">Manage your profile settings and view your activity.</p>
        {/* TODO: Add profile management component */}
      </div>
    </>
  );
}
